module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Opal Carew\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Opal Carew is the award-winning author of seven previous erotic romances for St. Martin's Press.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/P7FJn6/tc-custom/9781429996600.jpg?1732048750219",
      "alt": "This image is the cover for the book Secret Weapon"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Secret Weapon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("There's only one thing hotter than a man in uniform…when he takes it off.")]), _c('br'), _c('br'), _vm._v("Threesomes and men of the law have always been two of Janine's biggest turn-ons.  So when her boyfriend offers to invite one of his buddies from the police force into their bedroom, it's an offer she can't refuse.  But when the extra man shows up, the last thing she expects is for it to be Sloan Granger—a man from her past."), _c('br'), _c('br'), _vm._v("Janine is the one woman who Sloan's never been able to forget, and now that their worlds have collided, he has a second chance to win her back.  Even though she refuses to let him back into her life, he's determined to change her mind—no matter what the cost.  His love for her has always been his greatest weakness, but this time, it's also his most powerful weapon….")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0